<template>
  <div style="display: flex;flex-direction: column">
    <so-no-input v-model="job.jobSoNo" :disabled="disabled" style="margin-bottom: 5px" @change="onChange('jobSoNo')" />
    <el-checkbox v-model="job.predictionOperation" @change="onChange('predictionOperation')">{{ $t('SeaExport.PreAlertOperation') }}</el-checkbox>
  </div>
</template>

<script>
import soNoInput from '@/components/Cargo/Job/soNoInput'

export default {
  name: 'AeBasicJobSoNo',
  components: { soNoInput },
  props: {
    job: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    onChange(key) {
      this.$emit('childrenChange', [{ key, value: this.job[key] }])
    }
  }
}
</script>
